import { FC } from "react";

import importSuccess from "../../../assets/fonts/importSuccess.svg";
import { Notification } from "../../../types/global/types";
import "./styles.scss";

type Props = {
  notification: Notification;
};

export const ImportCompletedNotification: FC<Props> = ({ notification }) => {
  const notes = notification.notes as any;
  const householdsCreated: number | undefined = notes?.households_created;
  const personsCreated: number | undefined = notes?.persons_created;
  const rowsSkipped: number | undefined = notes?.rows_skipped;
  const duplicatesMerged: number | undefined = notes?.duplicates_merged;

  const hasStats =
    householdsCreated !== undefined ||
    personsCreated !== undefined;

  return (
    <div className="notification">
      <div className="notification__header">
        <div className="notification__reaction">
          <img src={importSuccess} alt={"importSuccessIcon"} />
        </div>
        <div className="notification__title">
          <h3>
            {notification.title.startOfTitle}
            {notification.title.householdName}
            {notification.title.endOfTitle}
          </h3>
          {hasStats && (
            <div className="notification__import-stats">
              {personsCreated !== undefined && personsCreated > 0 && (
                <div>{personsCreated} {personsCreated === 1 ? "person" : "people"} created</div>
              )}
              {householdsCreated !== undefined && householdsCreated > 0 && (
                <div>{householdsCreated} {householdsCreated === 1 ? "household" : "households"} created</div>
              )}
              {duplicatesMerged !== undefined && duplicatesMerged > 0 && (
                <div>{duplicatesMerged} {duplicatesMerged === 1 ? "duplicate" : "duplicates"} merged</div>
              )}
              {rowsSkipped !== undefined && rowsSkipped > 0 && (
                <div>{rowsSkipped} {rowsSkipped === 1 ? "row" : "rows"} skipped</div>
              )}
            </div>
          )}
          <div className="notification__time">
            {notification.created_at_formatted}
          </div>
        </div>
      </div>
    </div>
  );
};
